import { render } from "./S121617.vue?vue&type=template&id=d9969e4a"
const script = {}
script.render = render

export default script